import { render, staticRenderFns } from "./orgcompany-add-or-update.vue?vue&type=template&id=2cd19a0a&"
import script from "./orgcompany-add-or-update.vue?vue&type=script&lang=js&"
export * from "./orgcompany-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports